import { defineAction, object } from '~/prix'
import seedCityCensus from './seedCityCensus.action.json' with { type: 'json' }

const seedCityCensusDefinition = defineAction({
  ...seedCityCensus,
  input: object({}),
  output: object({}),
})

export default seedCityCensusDefinition
